export default __webpack_public_path__ + "static/media/icon-home-delete-hover.9792a03e.svg";